import React from 'react';
import { Button, colors, InputText } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import clsx from 'clsx';
import { useRootStore } from 'store/rootStore';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { NavigationClose } from '@insurancemenu/imenu-components-lib/dist/icons';
import { FormFields } from 'store/ui-stores/group-info/additionalAccessStore';
import { createStyles } from './styles';

interface EmployerFormProps {
  form: FormController<FormFields>;
  onAction: (e: React.FormEvent) => Promise<void>;
  onClose?: () => void;
  actionBtnText: string;
  formClassName?: string;
  formButtonIcon?: JSX.Element;
  userId?: string;
  isEmailDisabled?: boolean;
}

const EmployerForm = observer(
  ({
    form,
    onAction,
    actionBtnText,
    formClassName,
    formButtonIcon,
    userId,
    isEmailDisabled = false,
    onClose,
  }: EmployerFormProps): JSX.Element => {
    const {
      additionalAccessStore: { loading },
    } = useRootStore();

    const classes = createStyles();

    return (
      <div className={clsx(formClassName, classes.formWrapper)}>
        <form
          className={classes.dependentsForm}
          onSubmit={onAction}
          id={`${actionBtnText.toLowerCase().split(' ').join('-')}-form`}
        >
          {userId && (
            <Button
              className={classes.closeEditFormBtn}
              type="icon"
              color="custom"
              customColor={colors.blue[300]}
              onClick={onClose}
            >
              <NavigationClose />
            </Button>
          )}
          <InputText
            label="First Name"
            name="firstName"
            onChange={form.onFieldChange}
            value={form.fields.firstName.value}
            validationPassed={!form.fields.firstName.unpassedValidationMsg}
            validationMessage={form.fields.firstName.unpassedValidationMsg || ''}
            width="23rem"
            maxLength={50}
          />
          <InputText
            label="Middle Name"
            name="middleName"
            onChange={form.onFieldChange}
            value={form.fields.middleName.value}
            width="23rem"
            validationPassed={!form.fields.middleName.unpassedValidationMsg}
            validationMessage={form.fields.middleName.unpassedValidationMsg || ''}
            maxLength={50}
          />
          <InputText
            label="Last Name"
            name="lastName"
            onChange={form.onFieldChange}
            value={form.fields.lastName.value}
            width="23rem"
            validationPassed={!form.fields.lastName.unpassedValidationMsg}
            validationMessage={form.fields.lastName.unpassedValidationMsg || ''}
            maxLength={50}
          />
          <InputText
            label="Email"
            name="email"
            disabled={isEmailDisabled}
            onChange={form.onFieldChange}
            value={form.fields.email.value}
            width="23rem"
            validationPassed={!form.fields.email.unpassedValidationMsg}
            validationMessage={form.fields.email.unpassedValidationMsg || ''}
          />
          <InputText
            label="Phone"
            name="telephone"
            onChange={form.onFieldChange}
            value={form.fields.telephone.value}
            width="23rem"
            validationPassed={!form.fields.telephone.unpassedValidationMsg}
            validationMessage={form.fields.telephone.unpassedValidationMsg || ''}
          />
          <InputText
            label="Title"
            name="title"
            onChange={form.onFieldChange}
            value={form.fields.title.value}
            width="23rem"
            validationPassed={!form.fields.title.unpassedValidationMsg}
            validationMessage={form.fields.title.unpassedValidationMsg || ''}
          />
          <Button
            disabled={!form.isFormValid()}
            leftIconProp={formButtonIcon}
            className={classes.actionBtn}
            color="primary"
            size="large"
            onClick={onAction}
            htmlType="submit"
          >
            {actionBtnText}
          </Button>
        </form>
        <FormsSpinner display={loading} />
      </div>
    );
  },
);

export default EmployerForm;
